// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  padding-bottom: 2rem;
}

.powered-by-logo img {
  height: 100px;
}

.invert-centiro-logo {
  filter: invert(1);
}

.cobranding-light-theme {
  color: #000000;
}

.cobranding-dark-theme {
  color: #FFFFFF;
}

.co-branding-logo img {
  max-height: 80px;
  max-width: 150px;
  margin-left: 0.25rem;
  height: max-content;
}`, "",{"version":3,"sources":["webpack://./ClientApp/src/app/shared/components/footer/footer.component.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;AACF","sourcesContent":[".footer {\n  padding-bottom: 2rem;\n}\n\n.powered-by-logo img {\n  height: 100px;\n}\n\n.invert-centiro-logo {\n  filter: invert(1);\n}\n\n.cobranding-light-theme {\n  color: #000000;\n}\n\n.cobranding-dark-theme {\n  color: #FFFFFF;\n}\n\n.co-branding-logo img {\n  max-height: 80px;\n  max-width: 150px;\n  margin-left: 0.25rem;\n  height: max-content;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
